<template>
    <sub-controller></sub-controller>
</template>

<script>
    import ModelElement from "../../modeling/ModelElement";
    import VueSuperMethod from 'vue-super-call'
    import SubController from "../../../opengraph/shape/SubController";

    //Vue.prototype.$super = VueSuperMethod

    export default {
        components: {SubController},
        mixins: [ModelElement],
        name: 'sticky-model-element',
        props: {},
        data() {
            return {
                panelStyle: 'width:500px;',
                namePanel: '',
                descriptionPanel: '',
                rotateStatus: false,
                isMovedElement: false,
                attachedBoundedContext: false,
                attachedAggregate: false,
                failed_image: location.pathname + ((location.pathname == '/' || location.pathname.lastIndexOf('/') > 0) ? '' : '/') + 'static/image/symbol/info-icon-red.png',
                info_red_image: location.pathname + ((location.pathname == '/' || location.pathname.lastIndexOf('/') > 0) ? '' : '/') + 'static/image/symbol/close-icon-red.png',
                info_white_image: location.pathname + ((location.pathname == '/' || location.pathname.lastIndexOf('/') > 0) ? '' : '/') + 'static/image/symbol/info-icon-white.png',
            }
        },
        created: function () {
            var me = this
            //필수
            try {
                me.setUserInfo()
                var className = me.value ? me.value._type : null
                me.namePanel = me.value.name
                if (me.value.description) {
                    me.descriptionPanel = me.value.description
                }

                me.canvasbase = me.getComponent('sticky-model-canvas');


                if (className) {
                    var componentName = me.getComponentByClassName(className).name
                    var component = me.canvasbase.elementTypes.find(x => x.component == componentName)
                    if (component) {
                        me.img = component.src
                    }
                }

            } catch (e) {
                alert('Error: modelCanvas 선언 필수.', e)
            }
            // me.validate()
        },
        computed: {
            getNamePanel() {
                return this.namePanel
            },
            getDescriptionPanel() {
                return this.descriptionPanel
            },
            elementAuthor() {
                return this.value.author
            },
            isReadOnly() {
                if (this.canvasbase) {
                    return this.canvasbase.readOnly
                } else {
                    return false
                }
            },
            isCustomMoveExist() {
                if (this.canvasbase) {
                    if (this.canvasbase.isServerModeling && this.canvasbase.isQueueModeling) {
                        return !this.canvasbase.readOnly
                    }
                }
                return false
            },
            isEditElement() {
                if (this.canvasbase) {
                    if (this.canvasbase.readOnly) {
                        return false
                    } else {
                        if (this.canvasbase.information && this.canvasbase.information.author) {
                            if (localStorage.getItem('uid') == this.canvasbase.information.author) {
                                //project author
                                return true
                            } else {
                                if (this.elementAuthor) {
                                    return this.elementAuthor == localStorage.getItem('uid')
                                } else {
                                    if (this.canvasbase.information.author == this.userInfo.uid) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                            }
                        }
                    }
                }
                return true
            },
        },
        watch: {
            "value.name": function (newVal) {
                this.namePanel = newVal
                this.refresh()
            },
            "value.description": function (newVal) {
                this.descriptionPanel = newVal
                this.refresh()
            },
            "getNamePanel": {
                deep: true,
                handler: _.debounce(function (newVal, oldVal) {
                    if (newVal != oldVal)
                        this.refresh()
                }, 200)
            },
            "getDescriptionPanel": {
                deep: true,
                handler: _.debounce(function (newVal, oldVal) {
                    if (newVal != oldVal)
                        this.refresh()
                }, 200)
            },
            'staySelected': function (newVal, oldVal) {
                if (newVal) {
                    this.selectedStayActivity()
                } else {
                    this.deSelectedStayActivity()
                }

            },
            'selected': _.debounce(function (newVal, oldVal) {
                if (newVal) {
                    if (this.propertyPanel) {
                        this.staySelected = false
                    } else {
                        this.staySelected = true
                    }
                } else {
                    this.staySelected = false
                }

            }, 2000),
        },
        mounted() {
            var me = this
            me.$EventBus.$on('isMovedElement', function (id) {
                if (me.value.elementView) {
                    //only Element
                    if (me.value.elementView.id == id) {
                        me.isMovedElement = true
                        me.movedNewActivity()
                    } else {
                        if (me.isMovedElement == true) {
                            me.isMovedElement = false
                            me.movedOldActivity()
                        }
                    }
                }
            })

        },
        methods: {
            onMoveShape: function () {
                this.$EventBus.$emit('isMovedElement', this.value.elementView.id)
            },
            selectedActivity: function () {
                if (this.value) {
                    this.selected = true
                }
            },
            deSelectedActivity: function () {
                if (this.value) {
                    if (this.value._type == "StickyTextElement" && this.value.name.length == 0) {
                        this.propertyPanel = true
                        return
                    } else {
                        this.propertyPanel = false
                        this.selected = false
                        this.staySelected = false
                    }
                }
            },
            movedNewActivity() {
                var me = this
                if (me.isLogin && me.canvasbase.isServerModeling && !me.canvasbase.isClazzModeling && !me.isReadOnly) {
                    var obj = {
                        action: 'userMovedOn',
                        editUid: me.userInfo.uid,
                        name: me.userInfo.name,
                        picture: me.userInfo.profile,
                        timeStamp: Date.now(),
                        editElement: me.value.elementView.id
                    }
                    me.pushObject(`db://definitions/${me.params.projectId}/queue`, obj)
                }
            },
            movedOldActivity() {
                var me = this
                if (me.isLogin && me.canvasbase.isServerModeling && !me.canvasbase.isClazzModeling && !me.isReadOnly) {
                    var obj = {
                        action: 'userMovedOff',
                        editUid: me.userInfo.uid,
                        name: me.userInfo.name,
                        picture: me.userInfo.profile,
                        timeStamp: Date.now(),
                        editElement: me.value.elementView.id
                    }
                    me.pushObject(`db://definitions/${me.params.projectId}/queue`, obj)
                }
            },
            selectedStayActivity() {
                var me = this
                if (me.isLogin && me.canvasbase.isServerModeling && !me.canvasbase.isClazzModeling && !me.isReadOnly) {
                    var obj = {
                        action: 'userSelectedOn',
                        editUid: me.userInfo.uid,
                        name: me.userInfo.name,
                        picture: me.userInfo.profile,
                        timeStamp: Date.now(),
                        editElement: me.value.elementView.id
                    }
                    me.pushObject(`db://definitions/${me.params.projectId}/queue`, obj)
                }
            },
            deSelectedStayActivity() {
                var me = this
                if (me.isLogin && me.canvasbase.isServerModeling && !me.canvasbase.isClazzModeling && !me.isReadOnly) {
                    var obj = {
                        action: 'userSelectedOff',
                        editUid: me.userInfo.uid,
                        name: me.userInfo.name,
                        picture: me.userInfo.profile,
                        timeStamp: Date.now(),
                        editElement: me.value.elementView.id
                    }
                    me.pushObject(`db://definitions/${me.params.projectId}/queue`, obj)
                }

            },
            refresh() {
                this.refreshImg()
            },
            onRotateShape: function (element, angle) {
                // console.log('ES: onRotateShape: ', element,angle)
                // this.value.elementView.angle = angle
            },
            // validate() {
            //     var me = this

            //     if (!me.value._type.includes('BoundedContext') && !me.value._type.includes('Relation')) {
            //         if (me.canvasbase.attachedLists && me.canvasbase.attachedLists.boundedContextLists) {
            //             me.attachedBoundedContext = Object.values(me.canvasbase.attachedLists.boundedContextLists).some(bc => {
            //                 me.value.boundedContext = bc.name
            //                 return me.isAttached(bc);
            //             })
            //         }
            //     }

            //     if (!me.value._type.includes('Aggregate') && !me.value._type.includes('Relation')) {
            //         if (me.canvasbase.attachedLists && me.canvasbase.attachedLists.aggregateLists) {
            //             me.attachedAggregate = Object.values(me.canvasbase.attachedLists.aggregateLists).some(agg => {
            //                 return me.isAggAttached(agg)
            //             })
            //         }
            //     }

            // },
            isAggAttached: function (otherElement) {


                var me = this;

                var outer = {
                    x: (otherElement.elementView.x - otherElement.elementView.width / 2) - 10,
                    y: (otherElement.elementView.y - otherElement.elementView.height / 2) - 10,
                    width: otherElement.elementView.width + 20,
                    height: otherElement.elementView.height + 20
                }
                var inner = {
                    x: me.value.elementView.x - me.value.elementView.width / 2,
                    y: me.value.elementView.y - me.value.elementView.height / 2,
                    width: me.value.elementView.width,
                    height: me.value.elementView.height
                }


                return me._isAttached(outer, inner)
            },
            delayedMove(dx, dy, dw, dh, du, dlw, dl, dr) {
                var me = this

                var offsetX, offsetY, offsetW, offsetH

                var originX = me.value.elementView.x
                var originY = me.value.elementView.y
                var originW = me.value.elementView.width
                var originH = me.value.elementView.height

                if (me.isCustomMoveExist && me.params.projectId) {
                    me.movingElement = false
                    me.canvasbase.changed = true
                    var types = me.value._type.split('.')

                    if (dx == null && dy == null) {
                        // resize

                        if (Math.abs(dl) <= Math.abs(dr)) {
                            // 오른쪽으로 움직임
                            if (dr >= 0) {
                                offsetX = originX + (Math.abs(dl + dr) / 2.0)
                            } else {
                                offsetX = originX - (Math.abs(dl + dr) / 2.0)
                            }


                        } else if (Math.abs(dl) > Math.abs(dr)) {
                            // 왼쪽 으로 움직임
                            if (dl >= 0) {
                                offsetX = originX - (Math.abs(dl + dr) / 2.0)
                            } else {
                                offsetX = originX + (Math.abs(dl + dr) / 2.0)
                            }

                        }

                        if (Math.abs(dlw) <= Math.abs(du)) {
                            //위로 움직임
                            if (du >= 0) {
                                offsetY = originY - (Math.abs(du + dlw) / 2.0)
                            } else {
                                offsetY = originY + (Math.abs(du + dlw) / 2.0)
                            }

                        } else if (Math.abs(dlw) > Math.abs(du)) {
                            //아래로 움직임
                            if (dlw >= 0) {
                                offsetY = originY + (Math.abs(du + dlw) / 2.0)
                            } else {
                                offsetY = originY - (Math.abs(du + dlw) / 2.0)
                            }

                        }

                        offsetW = dw
                        offsetH = dh

                    } else if (dw == null && dh == null) {
                        //move
                        offsetX = originX + dx
                        offsetY = originY + dy
                        offsetW = originW
                        offsetH = originH
                    } else {
                        console.log('error Move & Resize')
                    }

                    var pushObj =
                        {
                            action: 'elementMove',
                            elementType: types[types.length - 1],
                            elementName: me.value.name,
                            editUid: localStorage.getItem('uid'),
                            elementId: me.value.elementView.id,
                            before: JSON.stringify({x: originX, y: originY, width: originW, height: originH}),
                            after: JSON.stringify({x: offsetX, y: offsetY, width: offsetW, height: offsetH}),
                            timeStamp: Date.now(),
                        }
                    me.pushObject(`db://definitions/${me.params.projectId}/queue`, pushObj)
                }
            },
            delayedRelationMove(vertices) {
                var me = this
                var orgineVertices = JSON.parse(JSON.stringify(me.value.relationView.value))
                var newVertices = []
                var offsetVertices

                if (me.isCustomMoveExist && me.params.projectId) {
                    me.movingElement = false
                    me.canvasbase.changed = true

                    vertices.forEach(function (ver, index) {
                        newVertices.push([ver.x, ver.y])
                    })
                    offsetVertices = JSON.stringify(newVertices)

                    var pushObj =
                        {
                            action: 'relationMove',
                            editUid: localStorage.getItem('uid'),
                            relationId: me.value.relationView.id,
                            before: orgineVertices,
                            after: offsetVertices,
                            timeStamp: Date.now(),
                        }
                    me.pushObject(`db://definitions/${me.params.projectId}/queue`, pushObj)
                }
            },
            getComponentByClassName: function (className) {
                var componentByClassName;

                // $.each(window.Vue.eventStormingModelingComponents, function (i, component) {
                $.each(window.Vue.stickyModelingComponents, function (i, component) {
                    if (component.default.computed && component.default.computed.className && component.default.computed.className() == className) {
                        componentByClassName = component.default;
                    }
                });
                return componentByClassName;
            },
        }
    }
</script>


<style scoped lang="scss" rel="stylesheet/scss">

</style>
